<panel width="600">
	<h1>{{ 'sale.order-warning.rejected-due-to' | translate }}</h1>
	<section>
		<reason-select [label]="'sale.order-warning.reasonlist-label' | translate" [(reasonId)]="selectedReasonId" [type]="reasonType.OrderWarning" [required]="true" />
		<textarea [(ngModel)]="comment" [placeholder]="'sale.order-warning.further-info' | translate"></textarea>
	</section>
	<section>
		<button confirm (click)="createOrderWarning()">{{ 'general.save' | translate }}</button>
	</section>
</panel>
